import { define, ui } from '@owenscorning/pcb.alpha';

export default ui`List`.of(ui`CTA`({ label: undefined }))({
  max: 3,
  label: 'CTAs',
  singular: 'CTA',
  title: item =>
    item.destination === 'pricespider' ? (
      <em>PriceSpider Buy Now</em>
    ) : (
      item.text
    ),
});
